import * as React from "react"
import { Container } from "shards-react"

import _ from "lodash"

const LowerFooter = props => (
  <Container className="bg-light" style={{ width: "100%" }}>
    <div className="p-4  text-center">
      <p>
        &#xa9; Copyright 2022{" "}
        <a className="text-primary" href={props.routes.home}>
          CSG Learning Institute
        </a>
        {props.country.name ? _.concat(", ", props.country.name) : null}
        <br />
        All rights reserved.
      </p>
    </div>
  </Container>
)

export default LowerFooter
